import _extends from "@babel/runtime-corejs3/helpers/extends";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import template from './alert.vdt';
export function addStaticMethods(Component) {
  var AlertDialog = /*#__PURE__*/function (_Component) {
    _inheritsLoose(AlertDialog, _Component);
    function AlertDialog() {
      return _Component.apply(this, arguments) || this;
    }
    return AlertDialog;
  }(Component);
  AlertDialog.template = template;
  AlertDialog.defaults = function () {
    return _extends({}, Component.defaults(), {
      title: undefined,
      type: 'success',
      size: 'mini',
      hideClose: true
    });
  };
  function show(options) {
    if (options === void 0) {
      options = {};
    }
    var normalize = Component.normalize;
    if (normalize) {
      if (options.content) {
        options = _extends({}, options, {
          content: normalize(options.content)
        });
      }
      if (options.icon) {
        options = _extends({}, options, {
          icon: normalize(options.icon)
        });
      }
    }
    var dialog = new AlertDialog(options);
    dialog.show();
    if (options.ref) options.ref(dialog);
    return new _Promise(function (resolve, reject) {
      dialog.on('ok', function () {
        resolve();
      });
      dialog.on('cancel', function () {
        reject();
      });
      // if press esc, treat it as cancel too
      dialog.on('terminate', function () {
        reject();
      });
    });
  }
  ['success', 'warning', 'error', 'confirm'].forEach(function (type) {
    Component[type] = function (options) {
      if (options === void 0) {
        options = {};
      }
      var closable = type === 'confirm';
      options = _extends({
        closable: closable,
        escClosable: closable
      }, options, {
        type: type
      });
      return show(options);
    };
  });
}